import http from "../http-common";

class queuingService {
  
  addToQueue(payload) {
    return http.post("/queue", payload);
  }

  getAll() {
    return http.get("/queue");
  }

  get(id) {
    return http.get(`/queue/${id}`);
  }

  getByBatch(id) {
    return http.get(`/queue/batch/${id}`);
  }

  update(id, data) {
    return http.put(`/queue/${id}`, data);
  }

  delete(id) {
    return http.delete(`/queue/${id}`,);
  }

  deleteAll() {
    return http.delete(`/queue`, );
  }


}

export default new queuingService();
